/**
 * Kestirimci bakim kartinin ("Kart ekle") form dogrulamasi.
 *
 * ## Neden gerekti
 *
 * Sayfada HICBIR dogrulama yoktu: "Değişikleri Kaydet" dugmesi dogrudan
 * `sendData` cagiriyordu ve o da govdeyi oldugu gibi gonderiyordu. Hicbir sey
 * secmeden basmak su govdeyi uretiyordu:
 *
 * ```
 * { blackboxId, uid, description: "", ioNumber: 0, ioDeviceId: "" }
 * ```
 *
 * Arka uc da alanlara bakmiyor (`AddPredictiveMaintenanceRequest`), yani girisi
 * ve urunu olmayan bir kart kaydediliyordu. O kayit sonra Yaklasik Kullanim
 * Omru tablosunda bos satir olarak goruniyor.
 *
 * ## `ioNumber` neden metin
 *
 * Secilen giris adi gidiyor ("Input-3"), sayi degil. Arka uc bunu
 * `PredictiveMaintenance.ioList` icinde oldugu gibi saklıyor ve tablo da
 * `ioList` uzerinden gosteriyor. Baslangic degeri eskiden sayi `0` idi, yani
 * hicbir sey secilmediginde gonderilen deger tipi bile farkliydi.
 */

/** Acilir listedeki yer tutucu. Secim yapilmadigini bu deger gosteriyor. */
export const GIRIS_YER_TUTUCU = 'input seç'

/**
 * @returns kullaniciya gosterilecek hata metni, ya da sorun yoksa `null`.
 */
export function kartGirdisiHatasi(
  giris: unknown,
  aciklama: unknown,
  urunId: unknown
): string | null {
  if (typeof giris !== 'string' || giris.trim() === '' || giris === GIRIS_YER_TUTUCU) {
    return 'Input seçin.'
  }
  if (typeof aciklama !== 'string' || aciklama.trim() === '') {
    return 'Açıklama girin.'
  }
  if (typeof urunId !== 'string' || urunId.trim() === '') {
    return 'Listeden bir ürün seçin.'
  }
  return null
}
